import type { FaireProductEntity } from "../../entity_types/product";

export const p_5rgxegpvyz: FaireProductEntity = {
  token: "p_5rgxegpvyz",
  type: "product",
  name: "Cat's Meow Notepad",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/d4a130cd92c2444510123fc4cb73c3a101b33dd94bfce8dfcaa7e95f167f416b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/08fc1d62962290996502ff5609da234cb23c7a4344cbf5676b6ce87d705f8115.png",
    "https://cdn.faire.com/fastly/2a946dcff2a8df82a8a241b9e58d049bd5f3f33901093cd34a8e59781ee13a4d.jpeg",
  ],
  priceDollars: 9,
  description:
    "Who doesn't love a fresh, crisp and clean new notepad?! It's such a hopeful item. Just think of all you will go through together! \n\nAt E. Frances, we want each page to bring joy to your list-making, doodling and note-taking.",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:36.912Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
